import { Grid, Grow, Stack } from "@mui/material";
import OverviewDetailed from "../selectors/OverviewDetailed";
import RoleSelect from "../selectors/RoleSelect";
import React, { useState } from "react";
import MultipleMetricsSelect from "../selectors/Shared/MetricsSelect";
import { GameMetrics } from "../../farsight-api";
import { targets } from "../../Context";
import TableDisplayGrid, { rowStyle } from "../datagrids/shared/TableDisplayGrid";
import { useReferentialContext } from "../../Context";

export const roles_to_number: { [target: string]: number } = {
    TOP_LANE: 1,
    JUNGLE: 2,
    MID_LANE: 3,
    BOT_LANE: 4,
    UTILITY: 5,
};

export default function SynergiesMatchups(props: { paramObject: any; target: targets; type: string }) {
    const api = useReferentialContext().farsightApi.getSummariesApi(props.target);
    const [detailed, setDetailed] = useState(true);
    const [matchupRole, setMatchupRole] = useState<string>(props.paramObject.role);
    const [metrics, setMetrics] = useState<GameMetrics[]>(useReferentialContext().selectedMetrics);

    const tabs = detailed ? [matchupRole] : ["TOP_LANE", "JUNGLE", "MID_LANE", "BOT_LANE", "UTILITY"];

    return (
        <Stack direction={"column"} sx={{ height: "100%", width: "100%" }} spacing={2}>
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                <Stack
                    direction={"row"}
                    sx={{
                        height: "50px",
                        justifyContent: "left",
                        width: "100%",
                    }}
                    spacing={2}
                >
                    <OverviewDetailed value={detailed} onChange={setDetailed} />
                    {!detailed ? <></> : <MultipleMetricsSelect values={metrics} updateValue={setMetrics} target={props.target} updateContext={false} />}
                    {!detailed ? <></> : <RoleSelect value={matchupRole} onChange={setMatchupRole} label={`${props.type} Role`} />}
                </Stack>
            </Grow>
            <Stack direction={"row"} sx={{ height: "100%", width: "100%" }} spacing={1}>
                {["TOP_LANE", "JUNGLE", "MID_LANE", "BOT_LANE", "UTILITY"].map((mu_role) => {
                    const champ_col = `${props.type === "Matchup" ? "enemy" : "ally"}${roles_to_number[mu_role]}`;
                    const request_parameters = {
                        ...props.paramObject,
                        groupby: champ_col,
                        metrics: detailed ? metrics.map((metric) => metric.code).toString() : ["performance", "relative_performance", "games", "winrate"].toString(),
                        ordering: "performance",
                        format: "json",
                    };
                    request_parameters.watermark = JSON.stringify(request_parameters);
                    return (detailed && tabs.includes(mu_role)) || !detailed ? (
                        <TableDisplayGrid
                            display_all={false}
                            request={() => api.aggregate(request_parameters)}
                            rowStyle={rowStyle.none}
                            disp_columns={detailed ? [champ_col] : [champ_col, "performance", "relative_performance", "games", "winrate"]}
                            sortBy={"performance"}
                            paramObject={request_parameters}
                            metrics={detailed ? metrics : []}
                        />
                    ) : (
                        <></>
                    );
                })}
            </Stack>
        </Stack>
    );
}
